import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-[#f7f7f5]">
        <div className="overline">Loading workspace…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
}
